import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StoreContext } from 'store';
import { useLazyQuery } from '@apollo/client';
import { userQuery } from '../../queries';
import { formatImageUrl } from '../../helpers';
import { Button } from 'components/Button';
import { Icon } from 'components/Icons';
import './search.scss';

//NX3KEVRH
//ZB4EGH54
//CE78Q8B5

export const Search = () => {
  const navigate = useNavigate();

  const {
    translation: t,
    loader: [showLoader, hideLoader],
  } = useContext(StoreContext);
  const [error, setError] = useState(false);
  const [lastRequest, setLastRequest] = useState<number | null>(null);

  const inputRef = useRef<HTMLInputElement>(null);
  const [getUser, { data }] = useLazyQuery(userQuery);

  useEffect(() => {
    if (!lastRequest) return;

    setError(!data);
  }, [lastRequest, data]);

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();

      const id = inputRef?.current?.value;

      if (!id || !id.length) {
        return;
      }

      showLoader();

      const { data: userData } = await getUser({ variables: { publicId: id } });

      setLastRequest(Date.now());

      if (userData) navigate(`/user/${id}`);

      hideLoader();
    } catch (error) {
      hideLoader();
    }
  };

  const onInput = function () {
    if (!inputRef.current) {
      return;
    }
    inputRef.current.value = inputRef.current.value.toUpperCase();
  };

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.value.length) setError(false);
  };

  return (
    <div
      className="search"
      style={{ backgroundImage: `url('${formatImageUrl('/img/search-bg.webp')}')` }}
    >
      <div className="container">
        <form onSubmit={onSubmit} className="search__form">
          <input
            onInput={onInput}
            onChange={onInputChange}
            ref={inputRef}
            type="text"
            className={'search__input ' + (!error ? '' : 'not-found')}
            placeholder={t.search.inputPlaceholder}
          />
          {error ? (
            <div className="search-error">
              <svg
                width="8"
                height="5"
                viewBox="0 0 8 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M4 0L0 5H8L4 0Z" fill="rgba(202, 26, 26, 0.9)" />
              </svg>
              <div className="search-error__title">{t.search.errorMessage.title}</div>
              <div className="search-error__subtitle">
                {t.search.errorMessage.subtitle}
              </div>
            </div>
          ) : null}
          <Button isIconLeft withTriangle Icon={Icon.Search} type="submit">
            {t.search.buttonText}
          </Button>
        </form>
      </div>
    </div>
  );
};
